import { DefineComponent } from 'vue';

import { IUseNotifications } from '@/bundles/App/composables/useNotifications';

// Type-only, empty at runtime. Vue 3 never runs a mixin's setup(), so a mixin that calls
// `this.addNotification(...)` relies on its host component returning `useNotifications()`
// from its own setup() bridge; listing this in the mixin's `mixins` types that contract.
export const NotificationsHostMixin = {} as DefineComponent<{}, IUseNotifications>;
